import * as Styled from './styled'
import { OptionProps, Props } from './interfaces'
import { useEffect, useRef } from 'react'

function DropDownMenu({
  isOpened,
  width,
  row,
  onClickOutside,
  options,
  onChange,
  comparisonProp,
  comparisonValue,
  renderOption,
}: Props) {
  const ref = useRef<HTMLUListElement>(null)

  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent) =>
      ref.current && !ref.current?.contains(target as Node) && onClickOutside?.()

    document.addEventListener('click', handleClickOutside, true)

    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [onClickOutside])

  function handleClickOption(option: OptionProps) {
    option.onClick?.(row)
    onChange?.(option)
    onClickOutside?.()
  }

  function shouldRenderOption(option: OptionProps) {
    return !option.hide && (!option.hideOnlyWhenMatch || row[comparisonProp] !== comparisonValue)
  }

  return (
    <Styled.DropDown ref={ref} $isOpened={isOpened} $width={width} role="list">
      {options.map(
        (option) =>
          shouldRenderOption(option) && (
            <Styled.Item role="option" key={option.id} onClick={() => handleClickOption(option)}>
              {renderOption ? renderOption(option) : (
                <>
                  {option.icon && <Styled.Icon name={option.icon} />}
                  {option.name}
                </>
              )}
            </Styled.Item>
          ),
      )}
    </Styled.DropDown>
  )
}

export default DropDownMenu
